module.exports = __webpack_public_path__ + "static/media/serv-box-small.4203ad9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/serv-box-small.jpg
// module id = 489
// module chunks = 0